import { Configuration, PopupRequest } from "@azure/msal-browser";

// MSAL configuration
export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_MICROSOFT_CLIENT_ID || "",
    // If your app is single-tenant, replace 'common' with your Directory (tenant) ID
    // Example: `https://login.microsoftonline.com/<tenant-id>`
    authority:
      process.env.REACT_APP_MICROSOFT_AUTHORITY ||
      "https://login.microsoftonline.com/common",
    redirectUri: window.location.origin + "/blank.html"
  },
  cache: {
    cacheLocation: "localStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
  }
};

// Add scopes here for ID token to be used at Microsoft Graph API endpoints.
export const loginRequest: PopupRequest = {
  scopes: ["User.Read"]
};
